import { Box, List, ListItemIcon, ListItemText, Tooltip, Typography } from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import { useLocation } from "react-router";
import useCustomizedNavigationRoutes from "../../hooks/use-customized-navigation-routes/UseCustomizedNavigationRoutes";
import { IRoute } from "../../routes/routes";
import { INavigationItem } from "../../services/navigation-data-service/Models";
import { IUICustomizationViewCategorySettingsDTO } from "../../services/ui-customization-data-service/Models";

export type NavigationViewListSectionProps = {
    open: boolean;
    navigationItem: INavigationItem;
    customizationSettings: IUICustomizationViewCategorySettingsDTO | undefined;
    viewAll: boolean;
    onClick: (navigationItem: INavigationItem, route: IRoute, shiftKey: boolean, ctrlKey: boolean) => void;
};

export default function NavigationViewListSection({
    open,
    navigationItem,
    customizationSettings,
    viewAll,
    onClick
}: NavigationViewListSectionProps) {
    const location = useLocation();

    const navigationRoutes = useCustomizedNavigationRoutes(
        navigationItem.objectTypeID,
        navigationItem.objectID,
        customizationSettings,
        viewAll
    );

    const currentRoute = navigationRoutes.find(o => o.fullPath === location.pathname);
    const selectedIndex = navigationRoutes.findIndex(o => o.viewID === (currentRoute?.parentViewID ?? currentRoute?.viewID));

    return (
        <List
            sx={{
                padding: 0,
                overflow: "hidden",
                display: 'flex',
                flexDirection: 'column',
                flex: '0 0 auto'
            }}
            dense={false}>
            {open &&
                <Typography
                    variant="subtitle1"
                    sx={{
                        fontWeight: 700,
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        paddingLeft: 1
                    }}>
                    {navigationItem.title}
                </Typography>
            }
            {navigationRoutes.map((route, index) =>
                // Exclude routes that have a parent view from the navigation drawer/rail
                (route.parentViewID === undefined) &&
                <ListItemButton
                    key={index}
                    selected={selectedIndex === index}
                    onClick={(event) => onClick && onClick(navigationItem, route, event.shiftKey, event.ctrlKey)}>

                    <ListItemIcon>
                        <Tooltip arrow placement="right" title={!open ? route.name : ""}>
                            <Box>
                                {<route.icon />}
                            </Box>
                        </Tooltip>

                    </ListItemIcon>

                    <ListItemText primary={route.name} />
                </ListItemButton>
            )}
        </List>
    );
}